import React, { useState } from 'react';
import { FaExpand, FaCompress } from 'react-icons/fa';

const ExpandableTile = ({ title, icon, children, className = '' }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    // تابع جداگانه برای مدیریت کلیک روی دکمه‌های کنترلی
    const handleToggleClick = (e) => {
        e.stopPropagation(); // جلوگیری از انتشار کلیک
        setIsExpanded(!isExpanded);
    };

    return (
        <div 
            className={`expandable-tile ${isExpanded ? 'expanded' : ''} ${className}`}
            style={{
                // تنظیمات گرید والد
                gridColumn: isExpanded ? 'span 4' : 'span 1',
                
                backgroundColor: 'rgba(255, 255, 255, 0.03)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '12px',
                overflow: 'hidden',
                cursor: 'default', // تغییر کرسر به پیش‌فرض چون کل کارت کلیک‌پذیر نیست
                position: 'relative',
                minHeight: '140px',
                transition: 'all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)',
            }}
            // حذف onClick از اینجا تا کل کارت کلیک‌پذیر نباشد
        >
            {/* --- حالت بسته (Minimized) --- */}
            {!isExpanded && (
                <div 
                    style={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        gap: '15px',
                        padding: '20px',
                        cursor: 'pointer' // فقط در حالت بسته، کل کارت کلیک‌پذیر باشد
                    }}
                    onClick={handleToggleClick}
                >
                    <div style={{ fontSize: '2.5rem', color: 'inherit' }}>
                        {icon}
                    </div>
                    <h3 style={{ 
                        margin: 0, 
                        fontSize: '1.1rem', 
                        color: '#fff',
                        fontWeight: '600'
                    }}>
                        {title}
                    </h3>
                    <div style={{ fontSize: '0.8rem', opacity: 0.5, marginTop: '5px' }}>
                        <FaExpand />
                    </div>
                </div>
            )}

            {/* --- حالت باز (Expanded) --- */}
            {isExpanded && (
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr',
                    gridTemplateRows: 'auto 1fr',
                    height: '100%',
                    width: '100%'
                }}>
                    {/* هدر افقی */}
                    <div style={{
                        padding: '10px 20px',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: '15px',
                        borderBottom: '1px solid rgba(255,255,255,0.1)',
                        backgroundColor: 'rgba(255,255,255,0.02)',
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{ fontSize: '1.5rem', color: 'inherit' }}>
                                {icon}
                            </div>
                            <h3 style={{ margin: 0, fontSize: '1rem', color: '#fff', fontWeight: '600' }}>
                                {title}
                            </h3>
                        </div>
                        
                        {/* دکمه بستن با کلیک اختصاصی */}
                        <div 
                            onClick={handleToggleClick}
                            style={{
                                fontSize: '1.1rem',
                                color: '#aaa',
                                padding: '5px',
                                borderRadius: '4px',
                                backgroundColor: 'rgba(0,0,0,0.2)',
                                cursor: 'pointer',
                                transition: 'background 0.2s'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.4)'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.2)'}
                        >
                            <FaCompress />
                        </div>
                    </div>

                    {/* محتوا */}
                    <div style={{ overflow: 'auto', padding: '20px' }}>
                        {children}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ExpandableTile;